import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { CoinRacesResponse, COIN_RACE_STATUS, COIN_RACE_TYPE, COIN_RACE_ORDER } from '@types';

const COIN_RACES_REQUEST_URL = '/coin_races';

export const GET_COIN_RACES_QUERY_KEY = ['coin-races', 'list'];

export type CoinRacesQueryParams = {
	lang?: string;
	type?: COIN_RACE_TYPE;
	status?: COIN_RACE_STATUS;
	order_end_date?: COIN_RACE_ORDER;
};

const buildQueryString = (params: CoinRacesQueryParams): string => {
	const queryParams = new URLSearchParams();

	if (params.lang) queryParams.append('lang', params.lang);
	if (params.type) queryParams.append('type', params.type);
	if (params.status) queryParams.append('status', params.status);
	if (params.order_end_date) queryParams.append('order_end_date', params.order_end_date);

	const queryString = queryParams.toString();
	return queryString ? `?${queryString}` : '';
};

export const useQueryCoinRaces = (params: CoinRacesQueryParams = {}) => {
	const queryString = buildQueryString(params);

	return useQuery<unknown, unknown, CoinRacesResponse>({
		queryKey: [GET_COIN_RACES_QUERY_KEY, params],
		queryFn: () => {
			return request<CoinRacesResponse>({
				method: 'get',
				url: getUrlToBackendApi(COIN_RACES_REQUEST_URL + queryString).href
			});
		},
		retry: false
	});
};

